export const base = {
  me: '/api/me',
  pageInfo: (pageID: any) => `/api/editor/pages/${pageID}`,
  savePage: '/api/page/savePage.html',
  event: (type: string | number, id: string | number, key: string | number) => `/api/pages/${type}/${id}/events/${key}`,

  template: {
    index: '/api/page/homePages.html',
    page: '/api/page/subPages.html',
    product: '/api/page/productPages.html',
    collection: '/api/page/collectionPages.html',
    article: '/api/page/articlePages.html',
  },
  getPublishedPage: 'api/page/publishedPages',
  getAssignedProducts: '/api/product/getAssignedProducts.html',
  unpublish: "/api/page/unpublish",
  stopCampaign: (id: number) => `api/campaigns/${id}/stop`,
  getElements: '/api/snippets',
  elementCRUD: (id: number | string) => `/api/snippets/${id}`,
  updateElement: (id: number | string) => `/api/snippets/update/${id}`,

  getTemplates: '/api/template/allTemplates.html',
  getTemplate: '/api/template/getTemplate.html',
  getTemplateTags: '/api/template/templateTags.html',

  getBlocks: '/api/block/allBlocks.html',
  getBlock: '/api/block/getBlock.html',

  getMyLibrary: '/api/mylibraries',
  checkShareLibrary: '/api/library/share/check',
  shareLibrary: '/api/library/share/create',
  removeMyTemplate: '/api/template/removeMyTemplate.html',
  removeMyBlock: '/api/block/removeMyBlock.html',
  updateMyTemplate: (id: number | string) => `/api/mylibraries/templates/${id}`,
  updateMyBlock: (id: number | string) => `/api/mylibraries/blocks/${id}`,
  createMyTemplate: '/api/template/newTemplate.html',
  createMyBlock: '/api/block/newBlock.html',
  systemSetting: '/api/system-settings/get-help',
  checkPassword: '/api/shop/checkPassword.html',
  pageSetting: (pageId: string) => `/api/pages/${pageId}/settings`,
  googleFontApi: (key = import.meta.env.VITE_APP_GOOGLE_FONT_KEY, sort = 'alpha') =>
    `https://content-webfonts.googleapis.com/v1/webfonts?key=${key}&sort=${sort}`,
  updateShortcut: '/api/v2/editor/update-shortcut',
  updateShopMeta: 'api/shop/getShopMeta.html',
  shopifyS3: 'https://shopify.s3.amazonaws.com',
  upgradeNewScope: '/api/shops/upgradeNewScope',
  updatePage: '/api/v2/pages/update-page',
};
export const getHelp = {
  articles: '/api/client/search',
  youtube: {
    playlist: (id: string, key: string) => `/playlistItems?part=snippet&maxResults=50&playlistId=${id}&key=${key}`,
    playlists: (key = 'AIzaSyAa8yy0GdcGPHdtD083HiGGx_S0vMPScDM') =>
      `/playlists?channelId=UCRUP8zvEDtEJrRtqCjbLJ0w&part=snippet%2CcontentDetails&maxResults=50&key=${key}`,
    video: (id: string, key: string) => `/videos?part=snippet,statistics&id=${id}&key=${key}`,
  },
};

export const shopmeta = {
  get: (key: string) => `/api/shopmeta?key=${key}`,
  base: '/api/shopmeta',
  batch: '/api/shopmeta/batch',
};
